import React from "react";
import { Button, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonWithEndIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Outlined button with end icon"}
        value={
          '<Button variant={"outlined"} endIcon={<ArrowRightIcon />}>Next</Button>'
        }
      >
        <Button variant={"outlined"} endIcon={<ArrowRightIcon />}>
          Next
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonWithEndIcon;
